import styled from '@emotion/styled'

import {Divider} from '@vio/atlas/Divider'
import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

const TABLET_CARD_WIDTH = 615

const Container = styled.div`
  border: 1px solid;
  border-color: ${cssTheme.colors.border.neutral.secondary};
  border-radius: ${cssTheme.layout.radius.lg};
  overflow: hidden;
  max-width: ${TABLET_CARD_WIDTH}px;
  margin-bottom: ${cssTheme.layout.spacing.s500};
`

interface BoVioFirstCardLoadingProps {
  isOTAMode?: boolean
}

export const BoVioFirstCardLoading = ({
  isOTAMode = false
}: BoVioFirstCardLoadingProps) => (
  <Container>
    <Box height="156px">
      <SkeletonLoader height="100%" />
    </Box>
    <Box padding="s500" height="118px">
      <SkeletonLoader width={252} />
      <SkeletonLoader width={175} />
    </Box>
    {!isOTAMode && <Divider />}
    <Box
      padding="s500"
      display="flex"
      justifyContent={isOTAMode ? 'flex-end' : 'space-between'}
    >
      {!isOTAMode && (
        <div>
          <SkeletonLoader width={139} />
          <SkeletonLoader width={90} />
        </div>
      )}
      <div>
        <SkeletonLoader width={56} align="right" />
        <SkeletonLoader width={86} align="right" />
      </div>
    </Box>
    <Divider />
    <Box padding="s500">
      <SkeletonLoader width={139} />
    </Box>
  </Container>
)
